"use client";

import {
  PreviewCertificate,
  type PreviewCertificateProps,
} from "./PreviewCertificate";

export type PreviewCertificateModalContentV2Props = PreviewCertificateProps;

/**
 * Cuerpo del modal de preview (§5.5 variante preview).
 * Sin min-h-screen, sin cards shadow-xl, sin headers gradient/backdrop-blur.
 */
export function PreviewCertificateModalContentV2(
  props: PreviewCertificateModalContentV2Props
) {
  return <PreviewCertificate {...props} />;
}
